import { filter, find, findIndex, get, last, uniq, pickBy, size } from "lodash";

export const getQuiz = (quizzes, quizID) => {
  return find(quizzes, { id: quizID });
};

export const getQuestion = (quizzes, quizID, questionID) => {
  const quiz = getQuiz(quizzes, quizID);

  return find(quiz.questions, { id: questionID });
};

export const getAnswer = (quizzes, quizID, questionID, answerID) => {
  const question = getQuestion(quizzes, quizID, questionID);

  return find(question.answers, { id: answerID });
};

export const getNextQuestion = (quizzes, quizID, questionID, country) => {
  const quiz = getQuiz(quizzes, quizID);

  // Get all "question" type questions
  const questions = filter(quiz.questions, { type: "question" });

  let index = findIndex(questions, { id: questionID });

  const nextQuestion = questions.find((question, i) => {
    if (i > index) {
      let countries = get(question, "country");

      // No Countries selected, use this question
      if (!countries) return question;

      countries = pickBy(countries, (val) => val === true);

      // No specific countries, this is the first question
      if (size(countries) < 1) return question;

      // Country specific, check our country is allowed
      if (country in countries) return question;
    }
  });

  return nextQuestion ? nextQuestion : null;
};

export const getProgress = (state) => {
  const { quizzes } = state;

  // Get all answers
  const answers = uniq(state.answers, (a) =>
    JSON.stringify([a.quiz, a.question])
  );

  if (!answers.length) return 0;

  // Get all the answered questions from this quiz
  const answered = filter(answers, { quiz: state.current.quiz });

  // Get current quiz we're answering
  const quiz = find(quizzes, { id: state.current.quiz });
  // Get all "question" type questions
  const questions = quiz.questions.filter((question) => {
    if (question.type !== "question") return false;

    const countries = pickBy(question.country, (val) => val === true);

    // No specific countries...
    if (size(countries) < 1) return true;

    // Country specific, check our country is allowed
    if (state.country in countries) return true;

    return false;
  });

  if (!answered.length) {
    const numerator = answers.length;
    const denominator = questions.length + answers.length;
    return Math.round((numerator / denominator) * 100);
  }

  // Get the last answer
  const lastAnswered = last(answered);

  // Find where lastAnswered is in quiz.questions array
  const index = findIndex(questions, { id: lastAnswered.question });

  const numerator = index + 1 + (answers.length - answered.length);
  const denominator = questions.length + (answers.length - answered.length);

  return Math.round((numerator / denominator) * 100);
};
